import React from 'react';

const LanguageToggle = ({ language, onLanguageChange }) => {
  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ];

  return (
    <select
      value={language}
      onChange={(e) => onLanguageChange(e.target.value)}
      style={{
        background: 'rgba(255, 255, 255, 0.2)',
        color: 'white',
        padding: '0.5rem 1rem',
        borderRadius: '9999px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        transition: 'all 0.3s'
      }}
    >
      {languages.map((lang) => (
        <option 
          key={lang.code} 
          value={lang.code}
          style={{ background: '#1f2937', color: 'white' }}
        >
          {lang.flag} {lang.name}
        </option>
      ))}
    </select>
  );
};

export default LanguageToggle;